import { render, staticRenderFns } from "./PortfolioFilterDefaultLayout.vue?vue&type=template&id=4771d45e&scoped=true&"
import script from "./PortfolioFilterDefaultLayout.vue?vue&type=script&lang=js&"
export * from "./PortfolioFilterDefaultLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4771d45e",
  null
  
)

export default component.exports